<template>
    <div v-bind:class="{'folder-selector-container': true, 'subfolder-selector-container': isSubfolder, 'disabled': uiIsDisabled}">
        <div class="folder-selector-loading" v-if="!isSubfolder && ((state == 'unk') || (state == 'loading'))">
            <strong>Loading...</strong>
        </div>
        <div class="folder-selector-error" v-else-if="state == 'error'">
            <strong>An error occurred while trying to list folders:</strong>
            {{error.apiResponseMessage}}
        </div>
        <div class="folder-selector-folder" v-else>
            <div v-if="properties">
                <span v-if="isSubfolder && ((state == 'collapsed') || (state == 'loading'))">&#128193;</span>
                <span v-if="isSubfolder && ((state == 'expanded') || (state == 'no-subfolders'))">&#128194;</span>
                <a href v-on:click.prevent="select" v-bind:class="{'folder-name': true, 'folder-selected': (properties.ID == selectedFolderID)}">{{properties.Name}}</a>
                <span v-if="isSubfolder && (state == 'collapsed')">[<a href v-on:click.prevent="expand">+</a>]</span>
                <span v-if="isSubfolder && (state == 'expanded')">[<a href v-on:click.prevent="collapse">-</a>]</span>
                <span v-if="isSubfolder && (state == 'loading')"><img src="../assets/Spin-1s-20px.gif"></span>
                <div class="subfolders">
                    <ul>
                        <li v-for="subfolder in subfolders" v-bind:key="subfolder.ID">
                            <component 
                                v-bind:is="'FolderSelector'"
                                v-bind:folderProperties="subfolder"
                                v-bind:initialState="'collapsed'"
                                v-bind:isSubfolder="true"
                                v-bind:selectedFolderIDProp="selectedFolderID"
                                v-bind:selectedObjectCustomerKeyProp="selectedObjectCustomerKey"
                                v-bind:listObjects="listObjectsInner"
                                v-bind:disabled="disabled"
                                v-on:Folder:select="subFolderSelected"
                                v-on:Folder:selectObject="selectObject"
                            ></component>
                        </li>
                        <li v-for="object in objects" v-bind:key="object.CustomerKey">
                            &#128196; <a href v-on:click.prevent="selectObject(objectType, object)" v-bind:class="{'object-name': true, 'object-selected': (object.CustomerKey == selectedObjectCustomerKey)}">{{object.Name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import flywheelSFMCUtilFactory from "@/services/flywheel-sfmc-util"

var folderContentTypesMap = {
    "dataextension": "DataExtension",
    "content": "ContentArea",
    "email": "Email",
    "automations": "Automation",
    // "media": "Portfolio",
    "queryactivity": "QueryDefinition",
    "shared_dataextension": "DataExtension",
    "shared_email": "Email",
    "triggered_send": "TriggeredSendDefinition",
    "userinitiatedsends": "EmailSendDefinition",
    "shared_content": "ContentArea",
    "synchronizeddataextension": "DataExtension",
    "shared_salesforcedataextension": "DataExtension",
    "salesforcedataextension": "DataExtension"/*,
    "ABTest": "AB test",
    "asset": "Asset",
    "automated_email": "simple automated emails",
    "BuildAudienceActivity": "Build audience activity",
    "campaign": "Campaign",
    "condensedlpview": "Condensed preview",
    "contextual_suppression_list": "Contextual suppression list",
    "document": "my documents",
    "ELTactivity": "ELT activity",
    "email_hidden_messagemodel": "Email hidden message model",
    "filteractivity": "Filter activities",
    "filterdefinition": "Data Filters",
    "global_email": "Global email",
    "global_email_sub": "Global email subscribers",
    "group": "my groups",
    "Hidden": "Hidden",
    "image": "my images",
    "job": "my tracking",
    "list": "my lists",
    "livecontent": "Live content",
    "measure": "Measures",
    "message": "Message",
    "microsite": "Microsites",
    "micrositelayout": "Microsite layouts",
    "mysubs": "my subscribers",
    "organization": "Organizations",
    "playbooks": "Playbooks",
    "programs2": "Programs",
    "publication": "Publication lists",
    "salesforcesends": "Salesforce sends",
    "salesforcesendsv5": "Salesforce sends v5",
    "shared_contextual_suppression_list": "Shared contextual suppression list",
    "shared_data": "Shared data",
    "shared_item": "Shared items",
    "shared_portfolio": "Shared portfolios",
    "shared_publication": "Shared publication lists",
    "shared_suppression_list": "Shared suppression lists",
    "shared_survey": "Shared surveys",
    "shared_template": "Shared templates",
    "ssjsactivity": "SSJS Activity",
    "suppression_list": "Suppression Lists",
    "survey": "my surveys",
    "template": "my templates",
    "triggered_send_journeybuilder": "Triggered sends Journey Builder",*/
};

export default {
    name: 'FolderSelector',
    props: [
        // Used in embed
        "rootFolderName",
        "rootFolderId",
        "autoSelectRoot",
        "listObjects",
        "disabled",

        // For internal use
        "folderProperties",
        "initialState",
        "isSubfolder",
        "selectedFolderIDProp",
        "selectedObjectCustomerKeyProp"
    ],
    data: function() {
        return {
            state: "init",
            properties: this.folderProperties ? Vue.util.extend({}, JSON.parse(JSON.stringify(this.folderProperties))) : null,
            selectedFolderID: this.selectedFolderIDProp,
            selectedObjectCustomerKey: this.selectedObjectCustomerKeyProp,
            subfolders: [],
            objects: [],
            error: null,
            objectType: null,
            listObjectsInner: (
                (typeof this.listObjects == 'string') ?
                (this.listObjects.toLowerCase() == 'true') :
                this.listObjects
            ),
            initialStateInner: this.initialState ? this.initialState : "expanded"
        }
    },
    created: function() {
        this.$sfmcUtil = flywheelSFMCUtilFactory(this);
        this.$folderUtil = flywheelSFMCUtilFactory(this, "folder");
        this.state = "unk";
        this.selectedFolderID = this.selectedFolderIDProp;
        this.selectedObjectCustomerKey = this.selectedObjectCustomerKeyProp;
    },
    mounted: function() {
        this.state = "unk";
        setTimeout(() => {
            this.initialize().
            then(
                () => {
                    if (this.autoSelectRoot && !this.isSubfolder && !this.listObjects) {
                        this.select();
                    }
                },
                () => {
                    // Do nothing
                }
            );
        }, 3);
    },
    computed: {
        creds: function() {
            return this.$sfmcAuth.get();
        },
        uiIsDisabled: function() {
            return (
                (
                    (typeof this.disabled == "boolean") &&
                    this.disabled
                ) ||
                (
                    (typeof this.disabled == "string") &&
                    (this.disabled == 'true')
                )
            );
        }
    },
    watch: {
        creds: function() {
            if (this.rootFolderName && (this.state != "loading")) {
                this.state = "unk";
                setTimeout(() => { this.initialize(true); }, 3);
            }
        },
        rootFolderName: function() {
            if (this.rootFolderName && (this.state != "loading")) {
                this.state = "unk";
                setTimeout(() => { this.initialize(true); }, 3);
            }
        },
        rootFolderId: function() {
            if (this.rootFolderId && (this.state != "loading")) {
                this.state = "unk";
                setTimeout(() => { this.initialize(true); }, 3);
            }
        },
        selectedFolderIDProp: function() {
            this.selectedFolderID = this.selectedFolderIDProp;
        },
        selectedObjectCustomerKeyProp: function() {
            this.selectedObjectCustomerKey = this.selectedObjectCustomerKeyProp;
        },
        state: function(state) {
            this.$emit('Folder:state', state);
        }
    },
    methods: {
        initialize: function(forceInitialize) {
            var promise;
            if (!this.properties || forceInitialize) {
                if (this.rootFolderId) {
                    promise = this.$folderUtil.apiCall(
                        "retrieve",
                        {
                            search_property: 'ID',
                            search_property_value: this.rootFolderId,
                            //get_properties: [
                            //    "Name",
                            //    "ID",
                            //    "ContentType",
                            //    "Client.ID"
                            //],
                            single_result: false
                        }
                    ).then(
                        (response) => {
                            //console.log(JSON.stringify(response, null, 4));
                            if (response.data && response.data.length) {
                                this.properties = response.data[0];
                                return Promise.resolve();
                            } else {
                                return Promise.reject({
                                    apiResponseMessage: `Unknown root folder name '${this.rootFolderName}'`
                                });
                            }
                        }
                    );
                } else {
                    promise = this.$folderUtil.apiCall(
                        "retrieve_from_path",
                        {
                            path: this.rootFolderName,
                            //get_properties: [
                            //    "Name",
                            //    "ID",
                            //    "ContentType",
                            //    "Client.ID"
                            //],
                            single_result: false
                        }
                    ).then(
                        (response) => {
                            //console.log(JSON.stringify(response, null, 4));
                            if (response.data && response.data.length) {
                                this.properties = response.data[0];
                                return Promise.resolve();
                            } else {
                                return Promise.reject({
                                    apiResponseMessage: `Unknown root folder name '${this.rootFolderName}'`
                                });
                            }
                        }
                    );
                }
            } else {
                promise = Promise.resolve();
            }
            return promise.then(
                () => {
                    if (this.initialStateInner == "expanded") {
                        this.expand();
                    } else {
                        this.state = this.initialStateInner;
                    }
                    return Promise.resolve();
                },
                (error) => {
                    this.state = "error"
                    this.error = error;
                    return Promise.reject();
                }
            );
        },
        collapse: function() {
            this.subfolders.splice(0, this.subfolders.length);
            this.objects.splice(0, this.objects.length);
            this.state = "collapsed";
        },
        expand: function() {
            var loadObjects = (contentType, categoryID) => {
                var objectType = folderContentTypesMap[contentType.toLowerCase()];

                if (!this.listObjectsInner || !objectType) {
                    return Promise.resolve();
                } else {
                    this.objectType = objectType;
                    return this.$sfmcUtil.apiCall(
                        "retrieve",
                        {
                            object_type: folderContentTypesMap[contentType],
                            search_property: "CategoryID",
                            search_property_value: categoryID,
                            get_properties: ["Name", "CustomerKey", "ObjectID"],
                            query_all_accounts: true
                        }
                    ).then(
                        (response) => {
                            response.data.forEach(object => {
                                this.objects.push(object);
                            })
                            this.objects.sort(function(a, b) {
                                a = a.Name.toLowerCase();
                                b = b.Name.toLowerCase();
                                if (a == b) {
                                    return 0;
                                } else {
                                    return (a < b) ? -1 : 1;
                                }
                            });
                            return Promise.resolve();
                        },
                        (error) => {
                            this.error = error;
                            this.state = "error"
                            return Promise.resolve();
                        }
                    );
                }
            };
            var loadFolder = () => {
                this.$folderUtil.apiCall(
                    "retrieve",
                    {
                        search_property: "ParentFolder.ID",
                        search_property_value: this.properties.ID,
                        get_properties: [
                            "Name",
                            "ID",
                            "ContentType"
                        ]
                    }
                ).then(
                    (response) => {
                        response.data.forEach(folder => {
                            this.subfolders.push(folder);
                        })
                        this.subfolders.sort(function(a, b) {
                            a = a.Name.toLowerCase();
                            b = b.Name.toLowerCase();
                            if (a == b) {
                                return 0;
                            } else {
                                return (a < b) ? -1 : 1;
                            }
                        });
                        //this.state = "expanded";
                        return loadObjects(
                            this.properties.ContentType,
                            this.properties.ID
                        ).then(
                            () => {
                                if (this.state != "error") {
                                    this.state = "expanded";
                                    //if (!this.subfolders.length && !this.objects.length) {
                                    //    this.state = "no-subfolders";
                                    //} else {
                                    //    this.state = "expanded";
                                    //}
                                }
                            }
                        )
                    },
                    (error) => {
                        this.error = error;
                        this.state = "error"
                        return Promise.resolve();
                    }
                );
            }
            if ((this.state == "expanded") || (this.state == "loading")) {
                return;
            }
            this.state = "loading";
            this.subfolders.splice(0, this.subfolders.length);
            this.objects.splice(0, this.objects.length);
            loadFolder();
        },
        select: function() {
            if (this.uiIsDisabled || this.listObjects) {
                return;
            }
            var folderName;
            if (!this.isSubfolder) {
                this.selectedFolderID = this.properties.ID;
                folderName = this.rootFolderName;
            } else {
                folderName = this.properties.Name;
            }
            this.$emit("Folder:select", this.properties.ID, folderName);
        },
        subFolderSelected: function(id, path) {
            var folderName;
            if (!this.isSubfolder) {
                this.selectedFolderID = id;
                folderName = this.rootFolderName;
            } else {
                folderName = this.properties.Name;
            }
            this.$emit("Folder:select", id, folderName+"/"+path);
        },
        selectObject: function(objectType, object, folderProperties) {
            if (this.uiIsDisabled) {
                return;
            }
            folderProperties = folderProperties || this.properties;
            //console.log('this.isSubfolder', this.isSubfolder);
            if (!this.isSubfolder) {
                this.selectedObjectCustomerKey = object.CustomerKey;
            }
            this.$emit("Folder:selectObject", objectType, object, folderProperties);
        }
    }
}
</script>
<style scoped lang="scss">
.folder-selector-container {
    $folder-selector-height: 200px;
    $folder-selector-padding-top: 4px;
    $folder-selector-padding-bottom: 8px;
    border: 1px solid gray;
    padding: $folder-selector-padding-top 8px $folder-selector-padding-bottom 8px;
    height: ($folder-selector-height + ($folder-selector-padding-top + $folder-selector-padding-bottom));
    overflow: hidden;
    display: block;
    &.disabled {
        color: gray;
        a, a:link, a:hover {
            color: gray;
        }
    }
    .folder-selector-folder {
        height: $folder-selector-height;
        overflow: auto;
    }
    .subfolder-selector-container {
        border: none;
        padding: 0;
        height: auto;
        display: inline;
        .folder-selector-folder {
            height: auto;
        }
    }
    .folder-selected {
        font-weight: bold;
        color: navy;
    }
    .object-selected {
        font-weight: bold;
        color: navy;
    }
}
</style>
